import React, { useState, useEffect } from "react";
import styles from "./FolderProgress.module.sass";
import { pb } from "../../../services/pocketbase";

//screens
import InvoiceCard from "./InvoiceCard";
import InvoiceGraph from "./InvoiceGraph";
import Overview from "./Overview";
import OpcoDetails from "./OpcoDetails";

const Comptability = ({ folderId }) => {
    const [contract, setContract] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFolderWithContract = async () => {
            try {
                setLoading(true);
                const folder = await pb.collection('folders').getOne(folderId, {
                    expand: 'contract_id'
                });

                const contract = folder.expand?.contract_id;
                
                if (contract) {
                    // Parser les données JSON si nécessaire
                    let echeances = [];
                    let detailsFacturation = {};
                    let engagementsFraisAnnexe = [];

                    // Parser echeances
                    if (contract.echeances) {
                        try {
                            echeances = typeof contract.echeances === 'string' 
                                ? JSON.parse(contract.echeances) 
                                : contract.echeances;
                        } catch (e) {
                            console.error('Erreur parsing echeances:', e);
                        }
                    }

                    // Parser detailsFacturation
                    if (contract.detailsFacturation) {
                        try {
                            detailsFacturation = typeof contract.detailsFacturation === 'string' 
                                ? JSON.parse(contract.detailsFacturation) 
                                : contract.detailsFacturation;
                        } catch (e) {
                            console.error('Erreur parsing detailsFacturation:', e);
                        }
                    }

                    // Parser engagementsFraisAnnexe
                    if (contract.engagementsFraisAnnexe) {
                        try {
                            engagementsFraisAnnexe = typeof contract.engagementsFraisAnnexe === 'string' 
                                ? JSON.parse(contract.engagementsFraisAnnexe) 
                                : contract.engagementsFraisAnnexe;
                        } catch (e) {
                            console.error('Erreur parsing engagementsFraisAnnexe:', e);
                        }
                    }

                    console.log('✅ Données parsées:');
                    console.log('- Echeances:', echeances);
                    console.log('- DetailsFacturation:', detailsFacturation);
                    console.log('- EngagementsFraisAnnexe:', engagementsFraisAnnexe);

                    const contractData = {
                        ...contract,
                        contractId: contract.id,
                        echeances,
                        detailsFacturation,
                        engagementsFraisAnnexe,
                        contractInfo: {
                            numero_interne: contract.numero_interne,
                            numero_deca: contract.numero_deca,
                            numero_externe: contract.numero_externe,
                            opco_status: contract.opco_status
                        }
                    };

                    console.log('📊 Contract final:', contractData);
                    setContract(contractData);
                }
            } catch (err) {
                console.error('Erreur lors de la récupération du contrat:', err);
            } finally {
                setLoading(false);
            }
        };

        if (folderId) {
            fetchFolderWithContract();
        }
    }, [folderId]);

    if (loading) {
        return <div>Chargement des données de comptabilité...</div>;
    }

    if (!contract) {
        return <div>Aucun contrat trouvé pour ce dossier.</div>;
    }

    return (
        <>
            <div className={styles.section}>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <Overview 
                            className={styles.card} 
                            comptabilityData={contract}
                            folderId={folderId}
                        />
                        {contract.echeances?.length > 0 ? (
                            contract.echeances.map((echeance, index) => (
                                <InvoiceCard 
                                    key={index}
                                    className={styles.card} 
                                    echeanceData={echeance}
                                    invoiceNumber={echeance.numero || index + 1}
                                    folderId={folderId}
                                />
                            ))
                        ) : (
                            <InvoiceCard 
                                className={styles.card} 
                                echeanceData={null}
                                invoiceNumber={1}
                                folderId={folderId}
                            />
                        )}
                    </div>
                    <div className={styles.col}>
                        <OpcoDetails className={styles.card} comptabilityData={contract} folderId={folderId} />
                        <InvoiceGraph className={styles.card} comptabilityData={contract} views="4" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Comptability;
